import { IconProps } from "./icon.type";

export function IcSidebarRoleManagementActive({ ...props }: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.002 12.2109C12.4528 12.2113 14.4655 13.9953 14.6768 16.2705C14.6843 16.3516 14.7119 16.4259 14.752 16.4922L12.9746 17.4678L11.7637 19.998H8.2373L7.02539 17.4678L5.25 16.4941C5.27214 16.4579 5.29176 16.42 5.30469 16.3789L5.32617 16.2705L5.35059 16.0586C5.66307 13.8852 7.62737 12.2109 10.002 12.2109ZM12.9746 2.52832L15.3242 3.81738L18.2373 3.54785L20 6.44824L18.2988 8.70996V11.2861L20 13.5479L18.2373 16.4482L15.8135 16.2246C15.8135 16.2085 15.816 16.1922 15.8145 16.1758C15.6209 14.0892 14.2098 12.3357 12.2607 11.5576C13.358 10.8628 14.081 9.6775 14.0811 8.33105C14.0808 6.1909 12.2545 4.45624 10.001 4.45605C7.74741 4.45619 5.92014 6.19087 5.91992 8.33105C5.91993 9.67751 6.64367 10.8628 7.74121 11.5576C5.87496 12.3028 4.50182 13.9424 4.21875 15.9121L4.1875 16.1758V16.2246L1.76367 16.4482L0 13.5479L1.70215 11.2861V8.70996L0 6.44824L1.76367 3.54785L4.67676 3.81738L7.02539 2.52832L8.2373 -0.00195312H11.7637L12.9746 2.52832ZM10.001 5.54102C11.6237 5.5412 12.9392 6.78998 12.9395 8.33105C12.9394 9.87228 11.6238 11.1219 10.001 11.1221C8.37808 11.1219 7.06251 9.87231 7.0625 8.33105C7.06272 6.78995 8.37822 5.54115 10.001 5.54102Z"
        fill="#00152C"
      />
    </svg>
  );
}
